const twitterCard = {
  Summary: 'summary',
  SummaryLargeImage: 'summary_large_image',
  App: 'app',
  Player: 'player',
};

export const DEFAULTS = {
  openGraphImageUrl:
    'https://cdn.evbstatic.com/s3-build/perm_001/6ce389/django/images/logos/eb_orange_on_white_1200x630.png', // Eventbrite Wordmark
  twitterCard,
  brandMark: 'Eventbrite',
};
